import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { Constants, ItemDetailSoldOutTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackItemDetailSoldOutFunctionArgs {
  readonly products: Product[];
  readonly stockAvailable: boolean;
  readonly variantId: string;
}

interface TrackItemDetailSoldOutFunction {
  (args: TrackItemDetailSoldOutFunctionArgs): void;
}

interface UseTrackItemDetailSoldOutFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackItemDetailSoldOutFunction {
  (agrs: UseTrackItemDetailSoldOutFunctionArgs): TrackItemDetailSoldOutFunction;
}

const useTrackItemDetailSoldOut: UseTrackItemDetailSoldOutFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<ItemDetailSoldOutTrackingEvent>();

  const trackItemDetailSoldOut: TrackItemDetailSoldOutFunction = useCallback(
    ({ products, stockAvailable, variantId }) => {
      emitUserEvent({
        event: TrackingEventName.ITEM_DETAIL_SOLD_OUT,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        items: products.map((product) => ({
          item_id: product._variantId,
          item_list_name: Constants.COMPLETE_YOUR_LOOK_LIST,
        })),
        items_str: variantId,
        stock_available: stockAvailable,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackItemDetailSoldOut;
};

export { useTrackItemDetailSoldOut };
